import { FirebaseError } from "firebase/app";
import { AuthErrorCodes } from "firebase/auth";
import { Link, useLocation, useNavigate } from "react-router";
import { LinkButton } from "../../components/Button";
import Divider from "../../components/Divider";
import Form from "../../components/Form";
import FormField from "../../components/FormField";
import East from "../../components/icons/east.svg?react";
import Input from "../../components/Input";
import SocialIdentityProviders from "../../components/SocialIdentityProviders";
import { useAuth } from "../../context/authContext";
import styles from "./Login.module.css";

interface LoginBody {
  email: string;
  password: string;
}

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();

  const state = location.state as { from: Location } | undefined;
  const from = state?.from.pathname ?? "/";

  return (
    <div>
      <header className={styles.header}>
        <Link to="#" className={styles.logo}>
          only clicks
        </Link>
      </header>
      <div className={styles.container}>
        <h1 className={styles.title}>Login to your account</h1>
        {/* <div className={styles.separator}></div> */}
        <Form<LoginBody>
          submitText="Login"
          onSubmit={({ value, formApi }) =>
            auth
              .signIn(value.email, value.password)
              .then(() => navigate(from, { replace: true }))
              .catch((err: FirebaseError) => {
                switch (err.code) {
                  case AuthErrorCodes.NETWORK_REQUEST_FAILED:
                    formApi.setErrorMap({
                      onServer: "No network connection." as never,
                    });
                    break;
                  case AuthErrorCodes.INVALID_EMAIL:
                    formApi.setFieldValue("password", "");
                    formApi.setErrorMap({
                      onServer: "Incorrect email or password." as never,
                    });
                    break;
                  case AuthErrorCodes.USER_DELETED:
                  case AuthErrorCodes.INVALID_PASSWORD:
                  case AuthErrorCodes.INVALID_LOGIN_CREDENTIALS:
                    formApi.setFieldValue("password", "");
                    formApi.setErrorMap({
                      onServer: "Incorrect email or password." as never,
                    });
                    break;
                  default:
                    formApi.setErrorMap({
                      onServer:
                        "Unexpected error occurred. Please try again." as never,
                    });
                    console.warn(`unhandled firebase error code ${err.code}`);
                }
              })
          }
        >
          {(form) => (
            <div className={styles.formFields}>
              <form.Field name="email">
                {(field) => (
                  <FormField label="Email address" field={field}>
                    <Input
                      id={field.name}
                      name={field.name}
                      type="email"
                      required={true}
                      value={field.state.value}
                      onBlur={field.handleBlur}
                      onChange={(e) => field.handleChange(e.target.value)}
                    />
                  </FormField>
                )}
              </form.Field>
              <form.Field name="password">
                {(field) => (
                  <FormField label="Password" field={field}>
                    <Input
                      id={field.name}
                      name={field.name}
                      type="password"
                      required={true}
                      value={field.state.value}
                      onBlur={field.handleBlur}
                      onChange={(e) => field.handleChange(e.target.value)}
                    />
                  </FormField>
                )}
              </form.Field>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/reset" /*, { state: { from: location } }*/);
                }}
              >
                Forgot passwort?
              </a>
            </div>
          )}
        </Form>
        <Divider text="or" />
        <SocialIdentityProviders
          onSuccess={() => navigate(from, { replace: true })}
        />
        <p className={styles.signup}>
          Don't have an account?
          <LinkButton linkProps={{ to: "/signup" }} glyph={East}>
            Get started
          </LinkButton>
        </p>
      </div>
    </div>
  );
};

export default Login;
